import { render, staticRenderFns } from "./Desconectar.vue?vue&type=template&id=c511e340"
import script from "./Desconectar.vue?vue&type=script&lang=js"
export * from "./Desconectar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports